import { Skeleton } from 'ui/skeleton';

import { EventInfo, SystemEventName } from '../../../../../domain';
import { TABLE_COLUMNS, ENTITIES } from '../../../constants';
import { Cell } from '../../../../../components/table';
import { useSubscribeEventsQuery } from '../../../../../hooks/useSubscribeEventsQuery';

import { UserEvents } from './UserEvents';
import { CampaignDetails } from './CampaignDetails';
import { NoDetails } from './NoDetails';
import { JourneyDetails } from './JourneyDetails';

interface EventHistoryDetailCellProps {
  userEvent: EventInfo;
}

export const EventHistoryDetailCell = ({ userEvent }: EventHistoryDetailCellProps) => {
  const { channels, lists, messageTypes, isLoading } = useSubscribeEventsQuery(userEvent);

  const hasChannels = !!channels.length && !isLoading;
  const hasLists = !!lists.length && !isLoading;
  const hasMessageTypes = !!messageTypes.length && !isLoading;

  const hasUserEvents = hasChannels || hasLists || hasMessageTypes;
  const noUserEvents =
    !userEvent.campaign && !hasChannels && !hasLists && !hasMessageTypes && !userEvent.workflowId;

  const isCampaignEvent = !hasUserEvents && !isLoading;
  const isJourneyExitEvent = userEvent.eventType === SystemEventName.journeyExit && !isLoading;
  const isNoEvent = noUserEvents && !isLoading;

  return (
    <Cell columnId={TABLE_COLUMNS.DETAILS} data-test="user-events-history-details">
      {isLoading && <Skeleton />}
      {!!userEvent.workflowId && isJourneyExitEvent && (
        <JourneyDetails workflowId={userEvent.workflowId} />
      )}
      {!!userEvent.campaign && isCampaignEvent && <CampaignDetails campaign={userEvent.campaign} />}
      {hasLists && <UserEvents events={lists} entityType={ENTITIES.LIST} />}
      {hasChannels && <UserEvents events={channels} entityType={ENTITIES.CHANNEL} />}
      {hasMessageTypes && <UserEvents events={messageTypes} entityType={ENTITIES.MESSAGETYPE} />}
      {isNoEvent && <NoDetails />}
    </Cell>
  );
};
